/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MbInputs */

const en_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MB`)
};

const es_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MB`)
};

const fr_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mo`)
};

const de_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MB`)
};

const ja_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MB`)
};

const zh_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MB`)
};

const ar_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميغابايت`)
};

const id_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MB`)
};

const it_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MB`)
};

const ru_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`МБ`)
};

const pt_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MB`)
};

const ko_mb = /** @type {(inputs: MbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MB`)
};

/**
* | output |
* | --- |
* | "MB" |
*
* @param {MbInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const mb = /** @type {((inputs?: MbInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MbInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mb(inputs)
	if (locale === "es") return es_mb(inputs)
	if (locale === "fr") return fr_mb(inputs)
	if (locale === "de") return de_mb(inputs)
	if (locale === "ja") return ja_mb(inputs)
	if (locale === "zh") return zh_mb(inputs)
	if (locale === "ar") return ar_mb(inputs)
	if (locale === "id") return id_mb(inputs)
	if (locale === "it") return it_mb(inputs)
	if (locale === "ru") return ru_mb(inputs)
	if (locale === "pt") return pt_mb(inputs)
	return ko_mb(inputs)
});